import datepicker from 'js-datepicker';
export default () => {

    const sd = document.getElementById("order-date-s").value;
    const startDate = (sd) => {
        if (sd !== '') {
            const [day, month, year] = sd.split(".");
            console.log(new Date(year, month - 1, day));
            return new Date(year, month - 1, day)
        }
        let start = new Date(Date.now());
        start.setDate(start.getDate() - 7);
        return start;

    };

    const ed = document.getElementById("order-date-e").value;
    const endDate = (ed) => {
        if (ed !== '') {
            const [day, month, year] = ed.split(".");
            return new Date(year, month - 1, day)
        }
        return new Date(Date.now())
    };


  datepicker('#order-date-s', {
        startDay: 1,
        customDays: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        customMonths: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
        formatter: (input, date, instance) => {
            const val = date.toLocaleDateString();
            input.value = val // => '1/1/2099'
        },
        dateSelected: startDate(sd)

    });

    const pickerEnd = datepicker('#order-date-e', {
        startDay: 1,
        position: 'br',
        customDays: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        customMonths: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
        formatter: (input, date, instance) => {
            const val = date.toLocaleDateString();
            input.value = val // => '1/1/2099'
        },
        dateSelected: endDate(ed)

    });

}
